import { LocationState } from 'history'
import { useWorkorderBaseRoute } from 'utils/Subscription/pathAndRouteSelector'
import { useWorkorderContext } from 'contexts/WorkorderContext/use-workorder-context'
import { useHistory } from 'react-router-dom'

// useOpenOrderForPartInGroup will try to open a product group page within a workorder
// you can override the default behaviour (open for employee order) by providing a overrideWorkorderUUID
export const useOpenOrderForPartInGroup = (productGroupUUID: string, overrideWorkorderUUID?: string) => {
  const { getWorkorderUUID } = useWorkorderContext()
  const baseURL = useWorkorderBaseRoute()
  const navigation = useHistory()

  const openOrder = async (state?: LocationState, onBeforePush?: () => void) => {
    const orderUUID = overrideWorkorderUUID || (await getWorkorderUUID({}))
    onBeforePush?.()
    navigation.push(`${baseURL}${orderUUID}/product-groups/${productGroupUUID}`, state)
  }

  return openOrder
}
